import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Offcanvas, CloseButton, Container, Spinner, ListGroup } from 'react-bootstrap'
import styles from './../style/TopSearch.module.scss'

export default class Main extends Component {
  sendForm = (e) => {
    e.preventDefault()
    this.props.changeTopSearch(true)
  }

  render() {
    const { search, changeSearch, top_search, changeTopSearch, loading, result } = this.props

    return (
      <Offcanvas className={styles.top_search} show={top_search} onHide={() => changeTopSearch()} placement={`top`}>
        <Offcanvas.Body className={styles.top_search_body}>
          <Container>
            <div className='d-flex align-items-center justify-content-between'>
              <form className={styles.searchContainer + ' d-lg-none me-4'} onSubmit={this.sendForm}>
                <input 
                  name="name"
                  type="text" 
                  placeholder="Поиск по каталогу"
                  className={styles.searchInput}
                  onChange={(e) => changeSearch(e.target.value)}
                  value={search}
                />
                <button title="Поиск" type="submit" className={styles.searchButton}>
                  <svg style={{ color: '#000', width: '16px', height: '16px' }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22448 15.2824C12.5702 15.2824 15.2824 12.5702 15.2824 9.22448C15.2824 5.87875 12.5702 3.1665 9.22448 3.1665C5.87875 3.1665 3.1665 5.87875 3.1665 9.22448C3.1665 12.5702 5.87875 15.2824 9.22448 15.2824Z" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15.8333 15.8333L14.1812 14.1812" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </form>
              <CloseButton onClick={() => changeTopSearch()} />
              <form className={styles.searchContainer + ' d-none d-lg-flex'} onSubmit={this.sendForm}>
                <input 
                  name="name"
                  type="text" 
                  placeholder="Поиск по каталогу"
                  className={styles.searchInput}
                  onChange={(e) => changeSearch(e.target.value)}
                  value={search}
                />
                <button title="Поиск" type="submit" className={styles.searchButton}>
                  <svg style={{ color: '#000', width: '16px', height: '16px' }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22448 15.2824C12.5702 15.2824 15.2824 12.5702 15.2824 9.22448C15.2824 5.87875 12.5702 3.1665 9.22448 3.1665C5.87875 3.1665 3.1665 5.87875 3.1665 9.22448C3.1665 12.5702 5.87875 15.2824 9.22448 15.2824Z" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15.8333 15.8333L14.1812 14.1812" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </form>
            </div>
          </Container>
          <div className={styles.top_search_sep}></div>
          <Container>
            {loading ?
              <div className="d-flex align-items-center justify-content-center py-5">
                <Spinner animation="grow" variant="dark" />
              </div>
            :
              <>
                {result == null ?
                  <div className="d-flex align-items-center justify-content-center py-5">
                    <div className="text-muted">Поиск товаров</div>
                  </div>
                :
                  <>
                    {result.count === 0 ?
                      <div className="d-flex align-items-center justify-content-center py-5">
                        <div className="text-center">
                          По запросу «{search}» товаров не найдено<br />
                          <small className="text-muted">Попробуйте изменить запрос</small>
                        </div>
                      </div>
                    :
                      <div className={styles.results_container}>
                        <div className="text-muted mb-2">
                          Найдено товаров: {result.count}
                        </div>
                        
                        <ListGroup className={styles.results_list}>
                          {result.products.map((product) => (
                            <ListGroup.Item 
                              key={product.id}
                              action 
                              href={product.url}
                              className={styles.result_item}
                            >
                              <div className="d-flex align-items-start">
                                {/* Маленькое фото товара слева */}
                                {product.image && (
                                  <div className="me-3" style={{ width: '60px', height: '60px', flexShrink: 0 }}>
                                    <img 
                                      src={product.image} 
                                      alt={product.title} 
                                      className="w-100 h-100 object-fit-contain border rounded p-1 bg-white"
                                    />
                                  </div>
                                )}
                                
                                <div className="d-flex justify-content-between align-items-start flex-grow-1">
                                  <div className="flex-grow-1 me-3">
                                    <div className="fw-semibold mb-1">{product.title}</div>
                                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                                      {product.article && (
                                        <small className="text-muted">Арт.: {product.article}</small>
                                      )}
                                      {product.manufacturer && (
                                        <small className="text-muted">• {product.manufacturer}</small>
                                      )}
                                    </div>
                                  </div>
                                  <div className="text-end">
                                    <div className="fw-bold">{product.price} ₽</div>
                                    {product.old_price > 0 && (
                                      <small className="text-muted text-decoration-line-through">
                                        {product.old_price} ₽
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </div>
                    }
                  </>
                }
              </>
            }
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
    )
  }
}

Main.propTypes = {
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  top_search: PropTypes.bool,
  changeTopSearch: PropTypes.func,
  loading: PropTypes.bool,
  result: PropTypes.object
}